<template>
    <div class="scroll-card" id="style-3">
        <span class="title">{{title}}</span>
        <div class="force-overflow"></div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ['title'],
    name: "ScrollCard",
}
</script>

<style scoped>
.scroll-card {
    position: relative;
    border-radius: 6px;
    padding: 0px 0 10px 0;
    width: 100%;
    overflow-x: hidden;
    overflow-y: scroll;
    border: 1px solid #e2e2e2;
    -webkit-box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
    box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.15);
    background-color: #fff;
    text-align: center;
    height: 120px;
}
.force-overflow{
	min-height: 0;
}
/* Style scroll */
#style-3::-webkit-scrollbar-track
{
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
	background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar
{
	width: 6px;
	background-color: #F5F5F5;
    cursor: pointer;
}

#style-3::-webkit-scrollbar-thumb
{
	background-color: #E91E24;
}

.title{
    position: sticky;
    width: 100%;
    left: 0;
    right: 0;
    top: 0px;
    padding: 5px 0;
    background: #fff;
    z-index: 10;
    box-shadow: 0 6px 10px 0 rgba(58, 59, 69, 0.15);
    display: block;
    font-size: 18px !important;
    font-weight: 700;
    font-family: inherit !important;
    margin-bottom: 15px;
}
</style>